

import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {AuthenticationService} from '../../services/authentication.service';
import {ValidateService} from '../../services/validate.service';
import * as Clipboard from 'clipboard';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user:Object;
  account:Object;
  public ip = location.host;
  account_id;
  public clipboard = new Clipboard('.btn');

  constructor(private validateService:ValidateService, private authService:AuthenticationService,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  ngOnInit() {
      this.authService.getProfile().subscribe((user) => {
        this.user=  user;
       //console.log(this.user[0].user);
       this.account_id = this.user[0].user.account_ID;
          this.getdataService.getAccountNameById(this.user[0].user.account_ID).subscribe((account) => {
            //console.log(account)
              this.account = account;
             
            },
          err=>{
            //////console.log(err);
            return false;
            });
      },
    err=>{
      //////console.log(err);
      return false;
      });
    }


    updateUserPassword =function(){
      this.submitted=true;
      let userpassword = this.elem.nativeElement.querySelector('#userpasswordtobemodified').value;
     // ////console.log(userpassword)
     // ////console.log(this.user[0].user._id)
      const user = {
        password: userpassword,
        accountID:  this.user[0].user._id
      }
  
      this.authService.updatedUserPassword(user).subscribe(data =>{
        if(data.success){
          alert('user updated');
        //  ////console.log("user updated");
        //  ////console.log(data);
            this.submitted=false;
  
        }else{
          alert('register failed');
            this.submitted=false;
        }
  
      });
    }
  
}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts